<template>
  <div class="city-list">
    <div slot="bread">
</div>
    <list-page-header :page-info="pageInfo">
     <div slot="bread">
   <router-link :to="{ name: 'home' }" class="color-white mytitle">holywoodskyline.com</router-link><span class="mytitle"> / </span>
</div>
      <div class="hero-search__left">
        <div class="hero-search__select fw">
          <v-select :options="city" placeholder="Select Genre" @onselect="selectGenre"/>
        </div>
      </div>
      <v-link
        :to="searchUrl"
        class="hero-search__submit green"
        icon="icon-search"
        icon-position="left"
        title="SEARCH MOVIE"
        @click.native="selectGenre"
      />
    </list-page-header>    
    <div class="city-list__inner">     
      <container>
        <div class="section__title fw text-center"><span class="color-light-green">Popular</span> TV Shows</div>
      <ContentLoader v-if="!featuredTVShows && !mobileCheck"
      :height="500">
        <rect x="2" y="0" rx="3" ry="3" width="195" height="70" />
        <rect x="202" y="0" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="0" rx="3" ry="3" width="95" height="70" />

        <rect x="2" y="75" rx="3" ry="3" width="95" height="70" />
        <rect x="103" y="75" rx="3" ry="3" width="95" height="70" /> 
        <rect x="202" y="75" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="75" rx="3" ry="3" width="95" height="70" />       
      </ContentLoader>
      <ContentLoader v-if="!featuredTVShows && mobileCheck"
      :height="400">
        <rect x="2" y="0" rx="3" ry="3" width="400" height="400"/>     
      </ContentLoader>      
        <div class="city-list__list">
          <div
            v-for="(show, $index) in featuredTVShows"
            :key="show.id"
            class="city-list__col"
            :class="[$index === 0 ? 'col-xl-6 col-lg-6 col-md-6' : 'col-xl-3 col-lg-3 col-md-3']">
            <NetworkCard
              :network="show"
            />
          </div>
        </div>

        <div class="city-list-result">
          <div class="result-bracket">
            <div class="result-bracket__title">
              <span class="result-bracket__count" v-if="networks">{{ networks.length }}</span> Networks Found!
            </div>
          </div>
      <ContentLoader v-if="!networks && !mobileCheck"
      :height="400">>
        <p>&nbsp;</p>
        <rect x="2" y="0" rx="3" ry="3" width="95" height="70" />
        <rect x="103" y="0" rx="3" ry="3" width="95" height="70" />
        <rect x="202" y="0" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="0" rx="3" ry="3" width="95" height="70" />

        <rect x="2" y="75" rx="3" ry="3" width="95" height="70" />
        <rect x="103" y="75" rx="3" ry="3" width="95" height="70" /> 
        <rect x="202" y="75" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="75" rx="3" ry="3" width="95" height="70" />

        <rect x="2" y="150" rx="3" ry="3" width="95" height="70" />
        <rect x="103" y="150" rx="3" ry="3" width="95" height="70" /> 
        <rect x="202" y="150" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="150" rx="3" ry="3" width="95" height="70" />

        <rect x="2" y="225" rx="3" ry="3" width="95" height="70" />
        <rect x="103" y="225" rx="3" ry="3" width="95" height="70" /> 
        <rect x="202" y="225" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="225" rx="3" ry="3" width="95" height="70" />           
      </ContentLoader>

      <ContentLoader v-if="!cities && mobileCheck">
        <rect x="3" y="0" rx="3" ry="3" width="376" height="440" />      
      </ContentLoader>

          <div class="city-list-result__list flex-row">
            <div class="city-list-result__item col-xl-3 col-md-4"
                 v-for="network in networks"
                 :key="network.id">
              <router-link :to="{ name: 'Network', params: { id: network.id, network: string_to_slug(network.name), genre: network.name }}" @click.native="onSelect(network)">
                <NetworkInfoCard
                  :network="network"
                />
              </router-link>
            </div>

            <!--<div class="city-list-result__bottom fw text-center">-->
              <!--<v-link-->
                <!--to="/movies"-->
                <!--class="button&#45;&#45;stroke round icon-transform"-->
                <!--title="Daha Fazla Gör"-->
                <!--icon="icon-arrow-long-right"-->
                <!--icon-position="right"-->
              <!--/>-->
            <!--</div>-->
          </div>

  <infinite-loading @infinite="infiniteHandler" spinner="waveDots" >
  <div slot="no-more"></div>
  <div slot="no-results"></div>
  </infinite-loading>

        </div>
      </container>
    </div>
  </div>
</template>

<script>
import ListPageHeader from '@/components/ListPageHeader'
import NetworkCard from '@/components/Network/NetworkCard'
import NetworkInfoCard from '@/components/Network/NetworkInfoCard'
import { ContentLoader } from 'vue-content-loader'
import InfiniteLoading from 'vue-infinite-loading'
import axios from 'axios'
export default {
  name: 'NetworkSearch',
  components: {
    ListPageHeader, NetworkCard, NetworkInfoCard, ContentLoader, InfiniteLoading, 
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Genres',
       meta: [
         { vmid: 'description', name: 'description', content: this.pageInfo.text },
         { vmid: 'keywords', name: 'keywords', content: 'movie, hollywood movies, italian movies, german movies, french movies, english movies, superhero movies ,american movies, holywoodskyline, search movie' }
       ],
       link: [
         { vmid: 'canonical', rel: 'canonical', href: window.location.origin + '/genres' }
       ]      
    }
  },  
  data () {
    return {
      errors: [],
      counter: 1,
      page: 2,
      pageInfo: {
        icon: require('@/assets/img/icon-city.svg'),
        // title: '<span class="color-light-green">Choose Your </span> Movie Genre!',
        title: '<span class="color-light-green">holywood</span>skyline',
        text: '' //'You can find movies in your city, can track movie information, can learn prices and buy tickets !'
      },
      city: [],
      cityID: null,
      // featuredGenres: null,
      countries: [
        {name: 'All Countries', code: 'DE'},
        {name: 'Germany', code: 'DE'},
        {name: 'Sweden', code: 'SE'},
        {name: 'France', code: 'FR'},
        {name: 'Italy', code: 'IT'},
        {name: 'Denmark', code: 'DK'},
        {name: 'England', code: 'GB'},
        {name: 'United States', code: 'US'},
        {name: 'Canada', code: 'CA'},
        {name: 'New Zealand', code: 'NZ'},
        {name: 'Mexico', code: 'MX'},
        {name: 'Japan', code: 'JP'},
        {name: 'Russia', code: 'RU'},
        {name: 'Brasil', code: 'BR'},
        {name: 'Belgium', code: 'BE'},
        {name: 'Crotia', code: 'HR'},
        {name: 'Australia', code: 'AU'},
        {name: 'Finland', code: 'FI'},
        {name: 'Switzerland', code: 'CH'},
        {name: 'Chez Republic', code: 'CZ'},
        {name: 'Austria', code: 'AT'},
        {name: 'Luxemburg', code: 'LU'},
        {name: 'South Korea', code: 'KR'},
        {name: 'Spain', code: 'ES'},
        {name: 'Norwey', code: 'NO'},
        {name: 'Israel', code: 'IS,'}
      ],
      list1: [],
networks: [
{
  headquarters: "",
  homepage: "",
  id: 54,
  name: "Disney Channel",
  origin_country: "US"
},
{
  headquarters: "New York City, New York",
  homepage: "http://www.mtv.com",
  id: 33,
  name: "MTV",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "https://www.history.com",
  id: 65,
  name: "History",
  origin_country: "US"
},
{
  headquarters: "Minato, Tokyo Prefecture",
  homepage: "http://www.fujitv.co.jp",
  id: 1,
  name: "Fuji TV",
  origin_country: "JP"
},
{
  headquarters: "New York City, New York",
  homepage: "http://abc.go.com",
  id: 2,
  name: "ABC",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "http://www.bbc.co.uk/bbcthree",
  id: 3,
  name: "BBC Three",
  origin_country: "GB"
},
{
  headquarters: "London, England",
  homepage: "https://www.bbc.co.uk/bbcone",
  id: 4,
  name: "BBC One",
  origin_country: "GB"
},
{
  headquarters: "Montréal, Québec",
  homepage: "",
  id: 5,
  name: "Bell TV",
  origin_country: "CA"
},
{
  headquarters: "New York City, New York",
  homepage: "http://www.nbc.com",
  id: 6,
  name: "NBC",
  origin_country: "US"
},

],

networks2: [
{
  headquarters: "",
  homepage: "https://www.maoritelevision.com",
  id: 8,
  name: "Māori Television",
  origin_country: "NZ"
},
{
  headquarters: "London, England",
  homepage: "https://www.itv.com",
  id: 9,
  name: "ITV",
  origin_country: "GB"
},
{
  headquarters: "",
  homepage: "",
  id: 10,
  name: "Discovery Health Channel",
  origin_country: "US"
},
{
  headquarters: "Beijing, China",
  homepage: "http://www.cctv.cn/",
  id: 11,
  name: "CCTV",
  origin_country: "CN"
},
{
  headquarters: "",
  homepage: "",
  id: 12,
  name: "HTB",
  origin_country: "JP"
},
{
  headquarters: "",
  homepage: "",
  id: 13,
  name: "Nickelodeon",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "",
  id: 14,
  name: "PBS",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "https://www.bbc.co.uk/cbbc",
  id: 15,
  name: "CBBC",
  origin_country: "GB"
},
{
  headquarters: "New York City, New York",
  homepage: "https://www.cbs.com",
  id: 16,
  name: "CBS",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "",
  id: 17,
  name: "MTV2",
  origin_country: "US"
},
{
  headquarters: "Ultimo, New South Wales",
  homepage: "https://www.abc.net.au",
  id: 18,
  name: "ABC",
  origin_country: "AU"
},
{
  headquarters: "Los Angeles, California",
  homepage: "https://www.fox.com",
  id: 19,
  name: "FOX",
  origin_country: "US"
},
{
  headquarters: "Quezon City",
  homepage: "http://entertainment.abs-cbn.com/Tv/Home",
  id: 20,
  name: "ABS-CBN",
  origin_country: "PH"
},
{
  headquarters: "",
  homepage: "",
  id: 21,
  name: "The WB",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "",
  id: 22,
  name: "Discovery Kids",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "http://www.cbc.ca/television",
  id: 23,
  name: "CBC Television",
  origin_country: "CA"
},
{
  headquarters: "",
  homepage: "https://www.bet.com",
  id: 24,
  name: "BET",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "",
  id: 25,
  name: "Televisión Nacional de Chile",
  origin_country: "CL"
},
{
  headquarters: "Leeds, England, UK",
  homepage: "https://www.channel4.com/",
  id: 26,
  name: "Channel 4",
  origin_country: "GB"
},
{
  headquarters: "New York City, New York",
  homepage: "https://www.univision.com",
  id: 28,
  name: "Univision",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "",
  id: 29,
  name: "ESPN",
  origin_country: "US"
},
{
  headquarters: "New York City, New York",
  homepage: "http://www.usanetwork.com",
  id: 30,
  name: "USA Network",
  origin_country: "US"
},
{
  headquarters: "Mainz, Rhineland-Palatinate",
  homepage: "https://www.zdf.de",
  id: 31,
  name: "ZDF",
  origin_country: "DE"
},

{
  headquarters: "New York City, New York",
  homepage: "https://www.mylifetime.com",
  id: 34,
  name: "Lifetime",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "",
  id: 35,
  name: "Nick Jr.",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "https://www.atv.com.tr/",
  id: 36,
  name: "atv",
  origin_country: "TR"
},
{
  headquarters: "",
  homepage: "",
  id: 37,
  name: "MSNBC",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "",
  id: 38,
  name: "Network Ten",
  origin_country: "AU"
},
{
  headquarters: "Tehran, Tehran Province",
  homepage: "http://tv5.ir",
  id: 39,
  name: "IRIB TV5",
  origin_country: "IR"
},
{
  headquarters: "",
  homepage: "",
  id: 40,
  name: "UPN",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "",
  id: 41,
  name: "TNT",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "http://www.tv5.com.ph/",
  id: 42,
  name: "TV5",
  origin_country: "PH"
},
{
  headquarters: "Washington, D.C.",
  homepage: "http://channel.nationalgeographic.com/",
  id: 43,
  name: "National Geographic",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "",
  id: 44,
  name: "Disney XD",
  origin_country: "US"
},
{
  headquarters: "New York City, New York",
  homepage: "http://www.foxnews.com",
  id: 45,
  name: "Fox News Channel",
  origin_country: "US"
},
{
  headquarters: "Toronto, Ontario",
  homepage: "https://www.ytv.com",
  id: 46,
  name: "YTV",
  origin_country: "CA"
},
{
  headquarters: "New York City, New York",
  homepage: "http://www.cc.com",
  id: 47,
  name: "Comedy Central",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "http://programme.tvb.com/jade",
  id: 48,
  name: "TVB Jade",
  origin_country: "HK"
},
{
  headquarters: "Nueva York, Nueva York, US",
  homepage: "https://www.hbo.com",
  id: 49,
  name: "HBO",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "",
  id: 50,
  name: "GMA Network",
  origin_country: "PH"
},
{
  headquarters: "",
  homepage: "",
  id: 51,
  name: "The Comedy Network",
  origin_country: "CA"
},
{
  headquarters: "Madrid",
  homepage: "https://www.telecinco.es",
  id: 53,
  name: "Telecinco",
  origin_country: "ES"
},
{
  headquarters: "New York, New York, United States",
  homepage: "http://www.spike.com",
  id: 55,
  name: "Spike",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "https://www.cartoonnetwork.com",
  id: 56,
  name: "Cartoon Network",
  origin_country: "US"
},
{
  headquarters: "Minato, Tokyo Prefecture, Japan",
  homepage: "https://www.ntv.co.jp",
  id: 57,
  name: "NTV",
  origin_country: "JP"
},
{
  headquarters: "",
  homepage: "",
  id: 58,
  name: "Televisa",
  origin_country: "MX"
},
{
  headquarters: "",
  homepage: "",
  id: 59,
  name: "CNN",
  origin_country: "US"
},
{
  headquarters: "Rio de Janeiro",
  homepage: "http://redeglobo.globo.com",
  id: 60,
  name: "Rede Globo",
  origin_country: "BR"
},
{
  headquarters: "",
  homepage: "",
  id: 61,
  name: "OUTtv",
  origin_country: "CA"
},
{
  headquarters: "",
  homepage: "http://www.logotv.com",
  id: 62,
  name: "Logo",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "",
  id: 63,
  name: "Game Show Network",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "https://www.discovery.com",
  id: 64,
  name: "Discovery",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "https://www.nine.com.au/",
  id: 66,
  name: "Nine Network",
  origin_country: "AU"
},
{
  headquarters: "New York City, New York, USA",
  homepage: "http://www.sho.com",
  id: 67,
  name: "Showtime",
  origin_country: "US"
},
{
  headquarters: "Atlanta, Georgia",
  homepage: "http://www.tbs.com",
  id: 68,
  name: "TBS",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "",
  id: 69,
  name: "Q",
  origin_country: "PH"
},
{
  headquarters: "",
  homepage: "",
  id: 70,
  name: "ESPN2",
  origin_country: "US"
},
{
  headquarters: "Burbank, California, United States",
  homepage: "http://www.cwtv.com/",
  id: 71,
  name: "The CW",
  origin_country: "US"
},
{
  headquarters: "Montréal, Québec",
  homepage: "https://noovo.ca/musiqueplus",
  id: 72,
  name: "MusiquePlus",
  origin_country: "CA"
},
{
  headquarters: "",
  homepage: "",
  id: 74,
  name: "Bravo",
  origin_country: "US"
},
{
  headquarters: "Burbank, California",
  homepage: "https://freeform.go.com",
  id: 75,
  name: "ABC Family",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "",
  id: 76,
  name: "E!",
  origin_country: "US"
},
{
  headquarters: "New York City, New York",
  homepage: "http://www.syfy.com/",
  id: 77,
  name: "Syfy",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "http://www.untvweb.com",
  id: 78,
  name: "DWAO-TV",
  origin_country: "PH"
},
{
  headquarters: "Atlanta, GA",
  homepage: "http://www.adultswim.com/",
  id: 80,
  name: "Adult Swim",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "",
  id: 81,
  name: "ESPNU",
  origin_country: "US"
},
{
  headquarters: " Tinley Park, Illinois",
  homepage: "http://wjys.tv",
  id: 82,
  name: "WJYS",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "",
  id: 83,
  name: "Teletoon",
  origin_country: "CA"
},
{
  headquarters: "",
  homepage: "",
  id: 84,
  name: "TLC",
  origin_country: "US"
},
{
  headquarters: "Nashville, Tennessee",
  homepage: "http://www.cmt.com",
  id: 85,
  name: "CMT",
  origin_country: "US"
},
{
  headquarters: "Southfield, Michigan",
  homepage: "https://www.foxsports.com/detroit",
  id: 87,
  name: "Fox Sports Detroit",
  origin_country: "US"
},
{
  headquarters: "Los Angeles, California, United States",
  homepage: "http://www.fxnetworks.com/fx",
  id: 88,
  name: "FX",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "",
  id: 90,
  name: "CBC News Network",
  origin_country: "CA"
},
{
  headquarters: "Silver Spring, Maryland",
  homepage: "https://www.animalplanet.com",
  id: 91,
  name: "Animal Planet",
  origin_country: "US"
},
{
  headquarters: "",
  homepage: "",
  id: 92,
  name: "City",
  origin_country: "CA"
},
{
  headquarters: "",
  homepage: "",
  id: 93,
  name: "Televisão Independente",
  origin_country: "PT"
},
{
  headquarters: "Kita, Osaka Prefecture",
  homepage: "https://www.mbs.jp",
  id: 94,
  name: "MBS",
  origin_country: "JP"
},
{
  headquarters: "",
  homepage: "",
  id: 95,
  name: "MediaCorp Channel 5",
  origin_country: "SG"
},
{
  headquarters: "Buenos Aires, Argentina",
  homepage: "https://telefe.com",
  id: 96,
  name: "Telefe",
  origin_country: "AR"
},
{
  headquarters: "Mapo District, Seoul",
  homepage: "http://www.imbc.com",
  id: 97,
  name: "MBC",
  origin_country: "KR"
},
{
  headquarters: "",
  homepage: "http://www.txhd.co.jp/",
  id: 98,
  name: "TV Tokyo",
  origin_country: "JP"
},
{
  headquarters: "",
  homepage: "",
  id: 99,
  name: "Channel 5",
  origin_country: "GB"
},
{
  headquarters: "",
  homepage: "https://www.bbc.co.uk/bbcfour",
  id: 100,
  name: "BBC Four",
  origin_country: "GB"
}
      ],
      searchUrl: {},
      errors: [],
      featuredTVShows: null,
    }
  },
  methods: {
        string_to_slug (str) {
        str = str.replace(/^\s+|\s+$/g, '') // trim
        str = str.toLowerCase()
  
        // remove accents, swap ñ for n, etc
        var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;"
        var to   = "aaaaeeeeiiiioooouuuunc------"
        for (var i=0, l=from.length ; i < l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
        }

        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-') // collapse dashes

        return str
    },
    infiniteHandler ($state) {
      this.page += 1
      let self = this
      axios
       // .get(`/site/cities/dorms/${this.$route.params.city}?page=${this.page}`)
        .get(`/3/network/${this.counter}?api_key=a11ac97c6bdb99adc0845654be0902a8`)
        .then(response => {
          if (response.status == 200 && response.status != 34) {
              self.networks.push(response.data)
              // self.popupDorms = response.data.data.popups
            $state.loaded()
            self.counter += 10
            /*else {
              $state.complete()
            }*/
          }
        })
        .catch(e => {
          self.errors.push(e)
        })

      //this.Counter += 10
      let counter1 = this.counter + 1
      let counter2 = this.counter + 9
      
      
      for (let i = 0 ; i ++, i < 10;) {
      axios
       // .get(`/site/cities/dorms/${this.$route.params.city}?page=${this.page}`)
        .get(`/3/network/${self.counter + i}?api_key=a11ac97c6bdb99adc0845654be0902a8`)
        .then(response => {
          // self.counter += 1
          if (response.status == 200 && response.status != 34) {
              self.networks.push(response.data)
              // self.popupDorms = response.data.data.popups
              
            /*else {
              $state.complete()
            }*/
          }
        })
        .catch(e => {
          self.errors.push(e)
        })   
     
      }
      // this.counter += 10
    },     
    onSelect (city) {
      // console.log(opt)
      window.localStorage.setItem('district_name', '')
      window.localStorage.setItem('studio', city.name)
      window.localStorage.setItem('genre', city.id)
    },
    selectGenre (opt) {
      // this.cityID = opt.id
      // this.searchUrl = { name: 'City', params: { slug: opt.slug, id: opt.id } }
      // console.log("sehir: " + this.$refs.myinput.value)
      // const selectedCity = this.$refs.myinput.value
      // let mycity = this.city.find(function (citty) { return citty.name == selectedCity } )
      // let slug = this.string_to_slug(this.$refs.myinput.value)
      window.localStorage.setItem('district_name', '')
      window.localStorage.setItem('studio', opt.slug)
      this.$router.push({ name: 'City', params: { city: opt.slug, id: opt.id } })
    },
    getPopularTVShows () {
      let self = this
      //axios.get('/site/home/cities?take=7')
      axios.get('/3/tv/popular?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US&page=1')
        .then(response => {
          self.featuredTVShows = response.data.results
          /*
              self.featuredTVShows.forEach((data) => {
                data.slug = string_to_slug(data.name)
            })*/
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    getCityList () {
      let self = this
      axios.get('/3/genre/movie/list?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US')
        .then(response => {
       //   self.genres = response.data.genres
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    getCities () {
      let self = this
      axios.get('/3/discover/movie?api_key=a11ac97c6bdb99adc0845654be0902a8&with_genres=28&page=2')
        .then(response => {
           self.city = response.data.results
/*          response.data.forEach(function(element) {
          self.city.push(element.name)
         })      */
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  created () {
   this.getPopularTVShows()
  //  this.getCities()
    this.getCityList() 
  },
  computed: {
    mobileCheck() {
     var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check
  },     
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/components/city-list";
</style>
